export class workspaceStatusConstant {
  static readonly OPEN: string = "OPEN";
  static readonly CLOSED: string = "CLOSED";
}
